export enum CardListSize {
  SMALL = 'small',
  MID = 'mid',
}

export enum CardListSelectColor {
  DEFAULT = 'default',
  PINK = 'pink',
}
